import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

const { carbon, blue } = colorsPalettes;

export const AllTabSectionDivider = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${carbon[50]};
`;

export const AllTabSectionToggleButton = styled.button`
    margin: 0;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
    text-align: right;
    ${setFontVariant("dataTable1", blue[400])};
    font-weight: 500;
`;
